module.exports = __webpack_public_path__ + "img/icon_aside_excel4_hover.bd0ac352.svg";